module.exports = __webpack_public_path__ + "img/grupos-edad-tm.14fb7d04.jpg";